import { render, staticRenderFns } from "./ActivitySettings.vue?vue&type=template&id=227f5d74"
import script from "./ActivitySettings.vue?vue&type=script&setup=true&lang=ts"
export * from "./ActivitySettings.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ActivitySettings.vue?vue&type=style&index=0&id=227f5d74&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports